import { render, staticRenderFns } from "./orderLogistics.vue?vue&type=template&id=e5e22262&scoped=true"
import script from "./orderLogistics.vue?vue&type=script&lang=js"
export * from "./orderLogistics.vue?vue&type=script&lang=js"
import style0 from "./orderLogistics.vue?vue&type=style&index=0&id=e5e22262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e22262",
  null
  
)

export default component.exports